import type { MealEstimate } from "../lib/types";

export default function TodayTotals({ totals, mealCount }: { totals: MealEstimate["totals"]; mealCount: number }) {
  return (
    <div className="mx-4 p-4 rounded-lg bg-slate-900 border border-slate-800">
      <div className="flex justify-between items-baseline">
        <span className="text-sm text-slate-400">Today · {mealCount} {mealCount === 1 ? "meal" : "meals"}</span>
      </div>
      <div className="text-3xl font-semibold mt-1">{Math.round(totals.calories)} kcal</div>
      <div className="flex gap-4 mt-2 text-sm text-slate-400">
        <span>P <span className="text-slate-200">{totals.protein_g.toFixed(0)}g</span></span>
        <span>C <span className="text-slate-200">{totals.carbs_g.toFixed(0)}g</span></span>
        <span>F <span className="text-slate-200">{totals.fat_g.toFixed(0)}g</span></span>
        {totals.fiber_g > 0 && <span>Fi <span className="text-slate-200">{totals.fiber_g.toFixed(0)}g</span></span>}
      </div>
    </div>
  );
}
